import * as React from "react"
import { useState } from "react"
import styled, { PolymorphicComponentProps } from "styled-components"
import { ChevronDownIcon } from "../../icons/ChevronDown"
import { ChevronUpIcon } from "../../icons/ChevronUp"
import { DeprecatedMenuListButton } from "./menuListButton"

const MenuListCmp = styled.details`
  margin: 0.25rem 0;
  padding: 0;
`

const MenuListEntries = styled.ul``

const MenuListTitle = styled.span`
  flex: 1;
  padding-left: 0.25rem;
`

const StyledChevronUpIcon = styled(ChevronUpIcon)`
  width: 0.75rem;
  height: 0.75rem;
`

const StyledChevronDownIcon = styled(ChevronDownIcon)`
  width: 0.75rem;
  height: 0.75rem;
`

export type DeprecatedMenuListProps<C extends React.ElementType> = PolymorphicComponentProps<
  "web",
  {
    listName: React.ReactNode
    icon: React.ReactNode
    "data-test-id"?: string
    isInitiallyOpen?: boolean
    selected?: boolean
    mode: "light" | "dark"
  },
  C,
  C
>

export const DeprecatedMenuList = <C extends React.ElementType = "ul">({
  listName,
  icon,
  children,
  isInitiallyOpen,
  selected,
  mode,
  ...props
}: DeprecatedMenuListProps<C>) => {
  const [menuOpen, setMenuOpen] = useState(isInitiallyOpen ?? false)

  const onToggle = () => {
    setMenuOpen(!menuOpen)
  }

  return (
    <MenuListCmp {...props} open={isInitiallyOpen} onToggle={onToggle}>
      <DeprecatedMenuListButton $variant="label-1" as="summary" mode={mode} selected={selected}>
        {icon}
        <MenuListTitle>{listName}</MenuListTitle>
        {menuOpen ? <StyledChevronUpIcon /> : <StyledChevronDownIcon />}
      </DeprecatedMenuListButton>

      <MenuListEntries>{children}</MenuListEntries>
    </MenuListCmp>
  )
}
